import { isFunction } from '@sureapp/wl-toggle-common/dist/services/envTypes';

import { TConfig, TConfigParams } from '@@/auto/interfaces';

export function handleFunctionConfig(
  config: TConfig | ((configParams: TConfigParams) => TConfig),
  opts: TConfigParams
): TConfig {
  return isFunction(config) ? config(opts) : config;
}
